import React, { useState, useEffect, useRef } from "react";
import { upload_file_to_s3, delete_file_from_s3 } from "../../components/S3";
import { toast } from "react-toastify";

import {
  Button,
  Box,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  OutlinedInput,
  Chip,
  Checkbox,
  ListItemText,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import api from "../../api/api";
import { deleteFileFromDB, UploadFileToAzureDB } from "../../components/Azure";

// Quiz Object
let quiz_object = {
  questionOrder: 0,
  questionId: "",
  question: "",
  questionMediaType: "",
  questionMedia: "",
  instructions: "",
  answerType: "",
  optionA: "",
  optionB: "",
  optionC: "",
  optionD: "",
  correctOption: [],
};

// Quiz Type List
const quiz_type_list = [
  { value: "yesNoOptions", label: "Yes/ No" },
  { value: "2options", label: "2 Options" },
  { value: "3options", label: "3 Options" },
  { value: "4options", label: "4 Options" },
  { value: "textInput", label: "Text Input" },
  { value: "imageInput", label: "Image Input" },
  { value: "audioInput", label: "Audio Input" },
  { value: "videoInput", label: "Video Input" },
];

const Quiz = ({ open, params, onSubmit, onClose }) => {
  const quizMediaFileRef = useRef();
  // --------- Set values on Page load in case of Update Operation ---------
  const [action, setAction] = useState("save");
  useEffect(() => {
    ////console.log("--> In Quiz Template - params : ", params);
    if (params && params.action === "update") {
      setAction("update");
      setQuestionOrder(params.quizObject.questionOrder);
      setQuestionId(params.quizObject.questionId);
      setQuestion(params.quizObject.question);
      setInstructions(params.quizObject.instructions);
      setQuestionMediaType(params.quizObject.questionMediaType);
      setQuestionMedia(params.quizObject.questionMedia);
      setAnswerType(params.quizObject.answerType);
      setOptionA(params.quizObject.optionA);
      setOptionB(params.quizObject.optionB);
      setOptionC(params.quizObject.optionC);
      setOptionD(params.quizObject.optionD);
      setCorrectOption(params.quizObject.correctOption);

      if (params.quizObject.answerType === "2options") setShowOptions2(true);
      else if (params.quizObject.answerType === "3options")
        setShowOptions3(true);
      else if (params.quizObject.answerType === "4options")
        setShowOptions4(true);
      else if (params.quizObject.answerType === "yesNoOptions")
        setShowOptionsYN(true);
    } else {
      setAction("save");
      setQuestionOrder(0);
      setQuestionId("" + new Date().getTime());
      setQuestion("");
      setInstructions("");
      setQuestionMediaType("");
      setQuestionMedia("");
      setAnswerType("");
      setOptionA("");
      setOptionB("");
      setOptionC("");
      setOptionD("");
      setCorrectOption([]);
    }
  }, [params]);
  // ----------------------------------------------------------------------

  // Quiz Type Sections
  const [showOptions2, setShowOptions2] = useState(false);
  const [showOptions3, setShowOptions3] = useState(false);
  const [showOptions4, setShowOptions4] = useState(false);
  const [showOptionsYN, setShowOptionsYN] = useState(false);

  // ---------------------- Question -------------------------
  const [questionOrder, setQuestionOrder] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [question, setQuestion] = useState("");
  // ---------------------------------------------------------

  // ---------------------- Instruction -------------------------
  const [instructions, setInstructions] = useState("");
  // ---------------------------------------------------------

  // ---------------------- Attach File ----------------------
  //const [questionMediaType, setQuestionMediaType] = useState("");
  //const [questionMedia, setQuestionMedia] = useState("");
  // ---------------------------------------------------------

  // ---------------------- Quiz Media Type ------------------------
  const [questionMediaType, setQuestionMediaType] = useState("");
  const [accept, setAccept] = useState("");
  const [showUploadPanel, setShowUploadPanel] = useState(false);
  const [questionMedia, setQuestionMedia] = useState("");

  const quiz_media_type_select_on_change = (e) => {
    setSelectedFile(null);
    //quizMediaFileRef.current.value = "";
    setQuestionMediaType(e.target.value);
    if (e.target.value === "image") {
      setAccept("image/*");
      setShowUploadPanel(true);
    } else if (e.target.value === "audio") {
      setAccept("audio/*");
      setShowUploadPanel(true);
    } else if (e.target.value === "video") {
      setAccept("video/*");
      setShowUploadPanel(true);
    } else {
      setAccept("");
      setShowUploadPanel(false);
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileExtensionType, setFileExtensionType] = useState("");
  const [myFile, setMyFile] = useState("");
  const [imgUrl, setImgUrl] = useState("");

  const quiz_media_file_on_change = (e) => {
    const file = e.target.files[0];
    const maxHeight = 612;
    const maxWidth = 612;

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileType = file.type;

      if (accept === "image/*" && file.size > 2097152) {
        toast.error("File size exceeds the maximum allowed (2 MB)");
        return;
      } else if (accept === "audio/*" && file.size > 5948300) {
        toast.error("File size exceeds the maximum allowed (4 MB)");
        return;
      } else if (accept === "video/*" && file.size > 20971520) {
        toast.error("File size exceeds the maximum allowed (20 MB)");
        return;
      }

      if (fileType.startsWith("video/")) {
        setFileExtensionType("mp4");
        setFileName(`quiz_${new Date().getTime()}.mp4`);
        // setSelectedFileType("video");

        const videoUrl = URL.createObjectURL(file); // Create a URL for the video file
        setMyFile(videoUrl); // Set the file URL
        setSelectedFile(file); // Set the selected video file
      } else if (fileType.startsWith("audio/")) {
        setFileExtensionType("mp3");
        setFileName(`quiz_${new Date().getTime()}.mp3`);
        // setSelectedFileType("audio");
        setMyFile(URL.createObjectURL(file)); // Set the audio file URL
        setSelectedFile(file); // Set the selected audio file
      } else if (fileType.startsWith("image/")) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = async () => {
            const { width, height } = img;

            if (width > maxWidth || height > maxHeight) {
              toast.error("Maximum height and width exceeded");
              return;
            }

            if (fileExtension === "png" || fileType === "image/png") {
              setFileExtensionType("png");
              setFileName(`quiz_${new Date().getTime()}.png`);
              // setSelectedFileType("image");
            } else if (
              fileExtension === "jpg" ||
              fileExtension === "jpeg" ||
              fileType === "image/jpeg"
            ) {
              setFileExtensionType("jpg");
              setFileName(`quiz_${new Date().getTime()}.jpg`);
              // setSelectedFileType("image");
            } else {
              console.error("It is neither a PNG nor a JPG file.");
              return;
            }

            setMyFile(e.target.result); // Set the base64 URL for the image
            setSelectedFile(file); // Set the selected image file
          };
        };

        reader.readAsDataURL(file);
      } else {
        console.error("Unsupported file type");
        return;
      }
    }
  };

  const resetAll = () => {
    setAction("save");
    setQuestionOrder(0);
    setSelectedFile(null);
    setMyFile("");
    setFileExtensionType("");
    setAccept("");
    setFileName("");
    setQuestionId("");
    setQuestion("");
    setQuestionMedia("");
    setQuestionMediaType("");
    setInstructions("");
    quiz_object["questionOrder"] = 0;
    quiz_object["questionId"] = "";
    quiz_object["question"] = "";
    quiz_object["questionMediaType"] = "";
    quiz_object["questionMedia"] = "";
    quiz_object["instructions"] = "";
    quiz_object["answerType"] = "";
    quiz_object["optionA"] = "";
    quiz_object["optionB"] = "";
    quiz_object["optionC"] = "";
    quiz_object["optionD"] = "";
    quiz_object["correctOption"] = [];
    reset();
  };
  // ---------------------------------------------------------
  const close_quiz_dialog = () => {
    resetAll();
    onClose();
  };

  const quiz_media_file_on_upload = async () => {
    if (selectedFile) {
      if (selectedFile.size > 4194304) {
        alert("File size exceed");
      } else {
        const result = await UploadFileToAzureDB(selectedFile, fileName);
        setQuestionMedia(result?.url || fileName);

        // upload_file_to_s3(selectedFile, (uploadPercentage) => {
        //   ////console.log(`Upload progress: ${uploadPercentage}%`);
        // })
        //   .then((s3Url) => {
        //     setQuestionMedia(s3Url);
        //     ////console.log("Upload success!", s3Url);
        //   })
        //   .catch((error) => {
        //     console.error("Upload failed!", error);
        //   });
      }
    } else {
      alert("No file choosen");
    }
  };

  const quiz_media_file_on_delete = (fileUrl) => {
    deleteFileFromDB(fileUrl);
    setQuestionMedia("");
    setQuestionMediaType("");
  };
  // ---------------------------------------------------------
  // ---------------------------------------------------------

  // ---------------------- Quiz Type ------------------------
  const [answerType, setAnswerType] = useState("");
  const quiz_type_select_on_change = (e) => {
    reset();
    setAnswerType(e.target.value);
    if (e.target.value === "2options") setShowOptions2(true);
    else if (e.target.value === "3options") setShowOptions3(true);
    else if (e.target.value === "4options") setShowOptions4(true);
    else if (e.target.value === "yesNoOptions") setShowOptionsYN(true);
  };
  // ---------------------------------------------------------

  // ---------------------- Option --------------------------
  const [optionA, setOptionA] = useState("");
  const [optionB, setOptionB] = useState("");
  const [optionC, setOptionC] = useState("");
  const [optionD, setOptionD] = useState("");
  // ---------------------------------------------------------

  // ---------------------- Correct Answer -------------------
  const [correctOption, setCorrectOption] = useState([]);
  const correct_answer_select_on_change = (e) => {
    const {
      target: { value },
    } = e;
    setCorrectOption(typeof value === "string" ? value.split(",") : value);
  };
  // ---------------------------------------------------------

  // ---------------------- Save -----------------------------
  const save_quiz = () => {
    if (
      question === undefined ||
      question === null ||
      question.trim().length <= 0
    )
      alert("Question is Missing");
    else {
      if (
        answerType === undefined ||
        answerType === null ||
        answerType.trim().length <= 0
      )
        alert("Quiz Type is Missing");
      else {
        if (action === "save") {
          setQuestionOrder(0);
          setQuestionId("" + new Date().getTime());
        }
        if (answerType === "yesNoOptions") save_optionsyn();
        else if (answerType === "2options") save_options2();
        else if (answerType === "3options") save_options3();
        else if (answerType === "4options") save_options4();
        else if (answerType === "textInput") save_optionsui_txt();
        else if (answerType === "imageInput") save_optionsUI_img();
        else if (answerType === "audioInput") save_optionsui_aud();
        else if (answerType === "videoInput") save_optionsui_vid();
        else alert("Something wnt wrong");
      }
    }
  };

  // useEffect(() => {
  //   const qId = new Date().getTime();
  //   ////console.log(qId, "qId");
  //   setQuestionId(qId);
  // }, [question]);

  const save_optionsyn = () => {
    ////console.log(">> save_optionsyn invoked");
    if (
      correctOption === undefined ||
      correctOption === null ||
      correctOption.length <= 0
    )
      alert("Correct Answers is Missing");
    else {
      quiz_object["questionOrder"] = questionOrder;
      quiz_object["questionId"] = questionId;
      quiz_object["question"] = question;
      quiz_object["questionMediaType"] = questionMediaType;
      quiz_object["questionMedia"] = questionMedia;
      quiz_object["instructions"] = instructions;
      quiz_object["answerType"] = answerType;
      quiz_object["optionA"] = "";
      quiz_object["optionB"] = "";
      quiz_object["optionC"] = "";
      quiz_object["optionD"] = "";
      quiz_object["correctOption"] = correctOption;
      ////console.log(">> quizdata sent from template: ", quiz_object);
      onSubmit(quiz_object);
      //resetAll();
    }
    resetAll();
  };

  const save_options2 = () => {
    ////console.log(">> save_options2 invoked");
    if (optionA === undefined || optionA === null || optionA.trim().length <= 0)
      alert("option A is Missing");
    else if (
      optionB === undefined ||
      optionB === null ||
      optionB.trim().length <= 0
    )
      alert("option B is Missing");
    else if (
      correctOption === undefined ||
      correctOption === null ||
      correctOption.length <= 0
    )
      alert("Correct Answers is Missing");
    else {
      quiz_object["questionOrder"] = questionOrder;
      quiz_object["questionId"] = questionId;
      quiz_object["question"] = question;
      quiz_object["questionMediaType"] = questionMediaType;
      quiz_object["questionMedia"] = questionMedia;
      quiz_object["instructions"] = instructions;
      quiz_object["answerType"] = answerType;
      quiz_object["optionA"] = optionA;
      quiz_object["optionB"] = optionB;
      quiz_object["optionC"] = "";
      quiz_object["optionD"] = "";
      quiz_object["correctOption"] = correctOption;
      quiz_object["optionType"] = correctOption.length > 1 ? "multi" : "single";
      ////console.log(">> quizdata sent from template: ", quiz_object);
      onSubmit(quiz_object);
      //resetAll();
    }
    resetAll();
  };

  const save_options3 = () => {
    ////console.log(">> save_options3 invoked");
    if (optionA === undefined || optionA === null || optionA.trim().length <= 0)
      alert("option A is Missing");
    else if (
      optionB === undefined ||
      optionB === null ||
      optionB.trim().length <= 0
    )
      alert("option B is Missing");
    else if (
      optionC === undefined ||
      optionC === null ||
      optionC.trim().length <= 0
    )
      alert("option C is Missing");
    else if (
      correctOption === undefined ||
      correctOption === null ||
      correctOption.length <= 0
    )
      alert("Correct Answers is Missing");
    else {
      quiz_object["questionOrder"] = questionOrder;
      quiz_object["questionId"] = questionId;
      quiz_object["question"] = question;
      quiz_object["questionMediaType"] = questionMediaType;
      quiz_object["questionMedia"] = questionMedia;
      quiz_object["instructions"] = instructions;
      quiz_object["answerType"] = answerType;
      quiz_object["optionA"] = optionA;
      quiz_object["optionB"] = optionB;
      quiz_object["optionC"] = optionC;
      quiz_object["optionD"] = "";
      quiz_object["correctOption"] = correctOption;
      quiz_object["optionType"] = correctOption.length > 1 ? "multi" : "single";
      ////console.log(">> quizdata sent from template: ", quiz_object);
      onSubmit(quiz_object);
      //resetAll();
    }
    resetAll();
  };

  const save_options4 = () => {
    ////console.log(">> save_options4 invoked");
    if (optionA === undefined || optionA === null || optionA.trim().length <= 0)
      alert("option A is Missing");
    else if (
      optionB === undefined ||
      optionB === null ||
      optionB.trim().length <= 0
    )
      alert("option B is Missing");
    else if (
      optionC === undefined ||
      optionC === null ||
      optionC.trim().length <= 0
    )
      alert("option C is Missing");
    else if (
      optionD === undefined ||
      optionD === null ||
      optionD.trim().length <= 0
    )
      alert("option D is Missing");
    else if (
      correctOption === undefined ||
      correctOption === null ||
      correctOption.length <= 0
    )
      alert("Correct Answers is Missing");
    else {
      quiz_object["questionOrder"] = questionOrder;
      quiz_object["questionId"] = questionId;
      quiz_object["question"] = question;
      quiz_object["questionMediaType"] = questionMediaType;
      quiz_object["questionMedia"] = questionMedia;
      quiz_object["instructions"] = instructions;
      quiz_object["answerType"] = answerType;
      quiz_object["optionA"] = optionA;
      quiz_object["optionB"] = optionB;
      quiz_object["optionC"] = optionC;
      quiz_object["optionD"] = optionD;
      quiz_object["correctOption"] = correctOption;
      quiz_object["optionType"] = correctOption.length > 1 ? "multi" : "single";
      ////console.log(">> quizdata sent from template: ", quiz_object);
      onSubmit(quiz_object);
      //resetAll();
    }
    resetAll();
  };

  const save_optionsui_txt = () => {
    ////console.log(">> save_optionsui_txt invoked");
    quiz_object["questionOrder"] = questionOrder;
    quiz_object["questionId"] = questionId;
    quiz_object["question"] = question;
    quiz_object["questionMediaType"] = questionMediaType;
    quiz_object["questionMedia"] = questionMedia;
    quiz_object["instructions"] = instructions;
    quiz_object["answerType"] = answerType;
    quiz_object["optionA"] = "";
    quiz_object["optionB"] = "";
    quiz_object["optionC"] = "";
    quiz_object["optionD"] = "";
    quiz_object["correctOption"] = [];
    ////console.log(">> quizdata sent from template: ", quiz_object);
    onSubmit(quiz_object);
    resetAll();

    //resetAll();
  };

  const save_optionsUI_img = () => {
    ////console.log(">> save_optionsUI_img invoked");
    quiz_object["questionOrder"] = questionOrder;
    quiz_object["questionId"] = questionId;
    quiz_object["question"] = question;
    quiz_object["questionMediaType"] = questionMediaType;
    quiz_object["questionMedia"] = questionMedia;
    quiz_object["instructions"] = instructions;
    quiz_object["answerType"] = answerType;
    quiz_object["optionA"] = "";
    quiz_object["optionB"] = "";
    quiz_object["optionC"] = "";
    quiz_object["optionD"] = "";
    quiz_object["correctOption"] = [];
    ////console.log(">> quizdata sent from template: ", quiz_object);
    onSubmit(quiz_object);
    resetAll();
  };

  const save_optionsui_aud = () => {
    ////console.log(">> save_optionsui_aud invoked");
    quiz_object["questionOrder"] = questionOrder;
    quiz_object["questionId"] = questionId;
    quiz_object["question"] = question;
    quiz_object["questionMediaType"] = questionMediaType;
    quiz_object["questionMedia"] = questionMedia;
    quiz_object["instructions"] = instructions;
    quiz_object["answerType"] = answerType;
    quiz_object["optionA"] = "";
    quiz_object["optionB"] = "";
    quiz_object["optionC"] = "";
    quiz_object["optionD"] = "";
    quiz_object["correctOption"] = [];
    ////console.log(">> quizdata sent from template: ", quiz_object);
    onSubmit(quiz_object);
    resetAll();
  };

  const save_optionsui_vid = () => {
    ////console.log(">> save_optionsui_vid invoked");
    quiz_object["questionOrder"] = questionOrder;
    quiz_object["questionId"] = questionId;
    quiz_object["question"] = question;
    quiz_object["questionMediaType"] = questionMediaType;
    quiz_object["questionMedia"] = questionMedia;
    quiz_object["instructions"] = instructions;
    quiz_object["answerType"] = answerType;
    quiz_object["optionA"] = "";
    quiz_object["optionB"] = "";
    quiz_object["optionC"] = "";
    quiz_object["optionD"] = "";
    quiz_object["correctOption"] = [];
    ////console.log(">> quizdata sent from template: ", quiz_object);
    onSubmit(quiz_object);
    resetAll();
  };
  // ---------------------------------------------------------

  // ---------------------- Reset ----------------------------
  const reset = () => {
    setAnswerType("");
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setCorrectOption([]);

    setShowOptions2(false);
    setShowOptions3(false);
    setShowOptions4(false);
    setShowOptionsYN(false);
  };

  //todo---------------------------console logs-------------------------------------------
  // console.log("selectedFile------------------------------->", selectedFile);
  // console.log("accept----------------------------------------->", accept);
  // console.log("params------------------------------>", params);
  console.log("myFile------------------------------->", myFile);
  // console.log("questionMedia----------------------------->", questionMedia);
  // console.log(
  //   "questionMediaType-------------------------->",
  //   questionMediaType
  // );

  return (
    <>
      <Dialog fullWidth maxWidth="lg" open={open}>
        <DialogTitle>Quiz Template</DialogTitle>
        <DialogContent>
          <div>
            {/* --------------------- */}
            <div>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <div>
                    {/* Add Question */}
                    <div className="quiz-parent-segment-title ">
                      Add Question
                    </div>
                    <div>
                      <TextField
                        id="add-question"
                        label="Add Question"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "470px" }}
                        size="small"
                        value={question}
                        onChange={(e) => setQuestion(e.target.value)}
                      />
                    </div>

                    {/* Add Quiz Media */}
                    <div className="quiz-parent-segment-title ">
                      Quiz Media (optional)
                    </div>
                    <div>
                      {!questionMedia && (
                        <div>
                          <FormControl fullWidth size="small">
                            <InputLabel id="quiz-type-select">
                              Select Quiz Media Type
                            </InputLabel>
                            <Select
                              labelId="quiz-type-label"
                              id="quiz-type-id"
                              value={questionMediaType}
                              label="Select Quiz Media Type"
                              onChange={quiz_media_type_select_on_change}
                            >
                              <MenuItem value="">None</MenuItem>
                              <MenuItem value="image">Image</MenuItem>
                              <MenuItem value="audio">Audio</MenuItem>
                              <MenuItem value="video">Video</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      )}
                      {accept && !questionMedia && (
                        <div>
                          <input
                            type="file"
                            accept={accept}
                            onChange={quiz_media_file_on_change}
                            ref={quizMediaFileRef}
                          />
                          <Button
                            variant="contained"
                            onClick={quiz_media_file_on_upload}
                          >
                            Add Quiz Media
                          </Button>
                        </div>
                      )}

                      <div style={{ marginTop: "1rem" }}>
                        {/* Preview Quiz Media */}
                        {questionMedia && (
                          <IconButton
                            color="error"
                            style={{ marginBottom: "0.5rem" }}
                            onClick={() => quiz_media_file_on_delete(questionMedia)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                        {questionMediaType === "image" &&
                          questionMedia &&
                          myFile ? (
                          <div>
                            <img src={myFile} style={{ maxWidth: "100%", maxHeight: "200px" }} />
                          </div>
                        ) : questionMediaType === "image" && questionMedia ? (
                          <div>
                            <img src={questionMedia} style={{ maxWidth: "100%", maxHeight: "200px" }} />
                          </div>
                        ) : null}
                        {questionMediaType === "audio" &&
                          questionMedia &&
                          myFile ? (
                          <div>
                            <audio src={myFile} controls />
                          </div>
                        ) : questionMediaType === "audio" && questionMedia ? (
                          <div>
                            <audio src={questionMedia} controls />
                          </div>
                        ) : null}
                        {questionMediaType === "video" &&
                          questionMedia &&
                          myFile ? (
                          <div>
                            <video src={myFile} controls style={{ maxWidth: "100%", maxHeight: "200px" }} />
                          </div>
                        ) : questionMediaType === "video" && questionMedia ? (
                          <div>
                            <video src={questionMedia} controls style={{ maxWidth: "100%", maxHeight: "200px" }} />
                          </div>
                        ) : null}
                      </div>

                    </div>
                  </div>
                </Grid>
                <Grid item xs={5}>
                  <div>
                    {/* Add Instruction */}
                    <div className="quiz-parent-segment-title ">
                      Add Instructions (optional)
                    </div>
                    <div>
                      <TextField
                        id="add-instructions"
                        label="Add Instructions"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "470px" }}
                        size="small"
                        value={instructions}
                        onChange={(e) => setInstructions(e.target.value)}
                      />
                    </div>

                    {/* Select Quiz Type */}
                    <div className="quiz-parent-segment-title ">
                      Select Quiz Type
                    </div>
                    <div>
                      <FormControl fullWidth size="small">
                        <InputLabel id="quiz-type-select">
                          Select Quiz Type
                        </InputLabel>
                        <Select
                          labelId="quiz-type-label"
                          id="quiz-type-id"
                          value={answerType}
                          label="Select Quiz Type"
                          onChange={quiz_type_select_on_change}
                        >
                          <MenuItem value="">Select</MenuItem>
                          {quiz_type_list.map((qtype) => (
                            <MenuItem key={qtype.value} value={qtype.value}>
                              {qtype.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <div>
                    {/* Preview Quiz Media moved below Select Quiz Media */}
                  </div>
                </Grid>
              </Grid>
            </div>
            {/* --------------------- */}

            {/* Load Options */}
            <div>
              {/* 2 Options Area */}
              {showOptions2 && (
                <div>
                  {/* Options Area */}
                  <div className="quiz-parent-segment-div">
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        {/* You can add Quiz Media Preview here */}
                      </Grid>
                      <Grid item xs={5}>
                        <div className="quiz-parent-segment-title ">
                          Add Options
                        </div>
                        <Grid container spacing={2}>
                          <Grid item xs={1}>
                            <div className="quiz-parent-segment-title ">A</div>
                          </Grid>
                          <Grid item xs={5}>
                            <div>
                              <TextField
                                id="option-a"
                                label="Option A"
                                variant="outlined"
                                size="small"
                                value={optionA}
                                onChange={(e) => setOptionA(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={1}>
                            <div className="quiz-parent-segment-title ">B</div>
                          </Grid>
                          <Grid item xs={5}>
                            <div>
                              <TextField
                                id="option-b"
                                label="Option B"
                                variant="outlined"
                                size="small"
                                value={optionB}
                                onChange={(e) => setOptionB(e.target.value)}
                              />
                            </div>
                          </Grid>
                        </Grid>
                        <br />
                        <div className="quiz-parent-segment-title ">
                          Choose Correct Option(s)
                        </div>
                        <div>
                          <FormControl fullWidth size="small">
                            <InputLabel id="quiz-type-select">
                              Select Correct Option(s)
                            </InputLabel>
                            <Select
                              multiple
                              labelId="coorect-answers-multiselect-chip-label"
                              id="coorect-answers-multiselect-chip"
                              value={correctOption}
                              onChange={correct_answer_select_on_change}
                              input={
                                <OutlinedInput
                                  id="select-multiple-chip"
                                  label="Select Correct Option(s)"
                                />
                              }
                              renderValue={(selected) => (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.5,
                                  }}
                                >
                                  {selected.map((value) => (
                                    <Chip key={value} label={value} />
                                  ))}
                                </Box>
                              )}
                            >
                              <MenuItem value="a">
                                <Checkbox
                                  checked={correctOption.indexOf("a") > -1}
                                />
                                <ListItemText primary="A" />
                              </MenuItem>
                              <MenuItem value="b">
                                <Checkbox
                                  checked={correctOption.indexOf("b") > -1}
                                />
                                <ListItemText primary="B" />
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              )}

              {/* 3 Options Area */}
              {showOptions3 && (
                <div>
                  {/* Options Area */}
                  <div className="quiz-parent-segment-div">
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        {/* You can add Quiz Media Preview here */}
                      </Grid>
                      <Grid item xs={5}>
                        <div className="quiz-parent-segment-title ">
                          Add Options
                        </div>
                        <Grid container spacing={2}>
                          <Grid item xs={1}>
                            <div className="quiz-parent-segment-title ">A</div>
                          </Grid>
                          <Grid item xs={5}>
                            <div>
                              <TextField
                                id="option-a"
                                label="Option A"
                                variant="outlined"
                                size="small"
                                value={optionA}
                                onChange={(e) => setOptionA(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={1}>
                            <div className="quiz-parent-segment-title ">B</div>
                          </Grid>
                          <Grid item xs={5}>
                            <div>
                              <TextField
                                id="option-b"
                                label="Option B"
                                variant="outlined"
                                size="small"
                                value={optionB}
                                onChange={(e) => setOptionB(e.target.value)}
                              />
                            </div>
                          </Grid>
                        </Grid>
                        <br />
                        <Grid container spacing={2}>
                          <Grid item xs={1}>
                            <div className="quiz-parent-segment-title ">C</div>
                          </Grid>
                          <Grid item xs={5}>
                            <div>
                              <TextField
                                id="option-c"
                                label="Option C"
                                variant="outlined"
                                size="small"
                                value={optionC}
                                onChange={(e) => setOptionC(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={1}>
                            <div></div>
                          </Grid>
                          <Grid item xs={5}>
                            <div></div>
                          </Grid>
                        </Grid>
                        <br />
                        <div className="quiz-parent-segment-title ">
                          Choose Correct Option(s)
                        </div>
                        <div>
                          <FormControl fullWidth size="small">
                            <InputLabel id="quiz-type-select">
                              Select Correct Option(s)
                            </InputLabel>
                            <Select
                              multiple
                              labelId="coorect-answers-multiselect-chip-label"
                              id="coorect-answers-multiselect-chip"
                              value={correctOption}
                              onChange={correct_answer_select_on_change}
                              input={
                                <OutlinedInput
                                  id="select-multiple-chip"
                                  label="Select Correct Option(s)"
                                />
                              }
                              renderValue={(selected) => (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.5,
                                  }}
                                >
                                  {selected.map((value) => (
                                    <Chip key={value} label={value} />
                                  ))}
                                </Box>
                              )}
                            >
                              <MenuItem value="a">
                                <Checkbox
                                  checked={correctOption.indexOf("a") > -1}
                                />
                                <ListItemText primary="A" />
                              </MenuItem>
                              <MenuItem value="b">
                                <Checkbox
                                  checked={correctOption.indexOf("b") > -1}
                                />
                                <ListItemText primary="B" />
                              </MenuItem>
                              <MenuItem value="c">
                                <Checkbox
                                  checked={correctOption.indexOf("c") > -1}
                                />
                                <ListItemText primary="C" />
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              )}

              {/* 4 Options Area */}
              {showOptions4 && (
                <div>
                  {/* Options Area */}
                  <div className="quiz-parent-segment-div">
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        {/* You can add Quiz Media Preview here */}
                      </Grid>
                      <Grid item xs={5}>
                        <div className="quiz-parent-segment-title ">
                          Add Options
                        </div>
                        <Grid container spacing={2}>
                          <Grid item xs={1}>
                            <div className="quiz-parent-segment-title ">A</div>
                          </Grid>
                          <Grid item xs={5}>
                            <div>
                              <TextField
                                id="option-a"
                                label="Option A"
                                variant="outlined"
                                size="small"
                                value={optionA}
                                onChange={(e) => setOptionA(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={1}>
                            <div className="quiz-parent-segment-title ">B</div>
                          </Grid>
                          <Grid item xs={5}>
                            <div>
                              <TextField
                                id="option-b"
                                label="Option B"
                                variant="outlined"
                                size="small"
                                value={optionB}
                                onChange={(e) => setOptionB(e.target.value)}
                              />
                            </div>
                          </Grid>
                        </Grid>
                        <br />
                        <Grid container spacing={2}>
                          <Grid item xs={1}>
                            <div className="quiz-parent-segment-title ">C</div>
                          </Grid>
                          <Grid item xs={5}>
                            <div>
                              <TextField
                                id="option-c"
                                label="Option C"
                                variant="outlined"
                                size="small"
                                value={optionC}
                                onChange={(e) => setOptionC(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={1}>
                            <div className="quiz-parent-segment-title ">D</div>
                          </Grid>
                          <Grid item xs={5}>
                            <div>
                              <TextField
                                id="option-d"
                                label="Option D"
                                variant="outlined"
                                size="small"
                                value={optionD}
                                onChange={(e) => setOptionD(e.target.value)}
                              />
                            </div>
                          </Grid>
                        </Grid>
                        <br />
                        <div className="quiz-parent-segment-title ">
                          Choose Correct Option(s)
                        </div>
                        <div>
                          <FormControl fullWidth size="small">
                            <InputLabel id="quiz-type-select">
                              Select Correct Option(s)
                            </InputLabel>
                            <Select
                              multiple
                              labelId="coorect-answers-multiselect-chip-label"
                              id="coorect-answers-multiselect-chip"
                              value={correctOption}
                              onChange={correct_answer_select_on_change}
                              input={
                                <OutlinedInput
                                  id="select-multiple-chip"
                                  label="Select Correct Option(s)"
                                />
                              }
                              renderValue={(selected) => (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.5,
                                  }}
                                >
                                  {selected.map((value) => (
                                    <Chip key={value} label={value} />
                                  ))}
                                </Box>
                              )}
                            >
                              <MenuItem value="a">
                                <Checkbox
                                  checked={correctOption.indexOf("a") > -1}
                                />
                                <ListItemText primary="A" />
                              </MenuItem>
                              <MenuItem value="b">
                                <Checkbox
                                  checked={correctOption.indexOf("b") > -1}
                                />
                                <ListItemText primary="B" />
                              </MenuItem>
                              <MenuItem value="c">
                                <Checkbox
                                  checked={correctOption.indexOf("c") > -1}
                                />
                                <ListItemText primary="C" />
                              </MenuItem>
                              <MenuItem value="d">
                                <Checkbox
                                  checked={correctOption.indexOf("d") > -1}
                                />
                                <ListItemText primary="D" />
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              )}

              {/* Yes/No Options Area */}
              {showOptionsYN && (
                <div>
                  {/* Options Area */}
                  <div className="quiz-parent-segment-div">
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        {/* You can add Quiz Media Preview here */}
                      </Grid>
                      <Grid item xs={5}>
                        <div className="quiz-parent-segment-title ">
                          Choose Correct Option(s)
                        </div>
                        <div>
                          <FormControl fullWidth size="small">
                            <InputLabel id="quiz-type-select">
                              Select Correct Option(s)
                            </InputLabel>
                            <Select
                              labelId="coorect-answers-multiselect-chip-label"
                              id="coorect-answers-multiselect-chip"
                              value={correctOption}
                              onChange={correct_answer_select_on_change}
                              input={
                                <OutlinedInput
                                  id="select-multiple-chip"
                                  label="Select Correct Option(s)"
                                />
                              }
                              renderValue={(selected) => (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.5,
                                  }}
                                >
                                  {selected.map((value) => (
                                    <Chip key={value} label={value} />
                                  ))}
                                </Box>
                              )}
                            >
                              <MenuItem value="yes">
                                <Checkbox
                                  checked={correctOption.indexOf("yes") > -1}
                                />
                                <ListItemText primary="YES" />
                              </MenuItem>
                              <MenuItem value="no">
                                <Checkbox
                                  checked={correctOption.indexOf("no") > -1}
                                />
                                <ListItemText primary="NO" />
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={close_quiz_dialog}>Cancel</Button>
          <Button variant="contained" onClick={save_quiz}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Quiz;
